import { selectedDateRangeRest } from "../Pickers/dataRange";
import axios from "axios";
import { restErrorHandler } from "../../helpers/restErrorHandler";
import { RestApiState } from "../../interfaces/Rest/types";
import { 
    JournalResponse,
    JournalRequestParams,
} from "../../interfaces/Journal/types";

function generateQueryString(params: any): string {
    // TODO function duped
    const queryString = Object.entries(params)
        .filter(([key, value]) => value !== undefined) // filter out undefined values
        .map(([key, value]) => {
            if (key === 'offset' && params.limit && params.currentPage) {
                value = (params.currentPage - 1) * params.limit
            }
            if (key === 'currentPage') {
                return null
            }

            if (key === 'dateRange') {
                key = 'period'
                value = selectedDateRangeRest(params.dateRange.range)
            }

            return `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`;
        })
        .join('&'); // Join the key-value pairs with '&'

    return queryString ? `?${queryString}` : '';
}


export const fetchJournal = async (serialNumber:string, role:string, params: JournalRequestParams): Promise<JournalResponse | null | void> => {
    const url = `${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/acb/${serialNumber}/journal${generateQueryString(params)}`
    
    try {
        const response = await axios.get<JournalResponse>(url,
            { withCredentials: true }
        )
        if (response.status === 200) {
            return response.data
        } else {
            return null
        }
    } catch (error:any) {
        console.log("Error fetching chart data details:", error)
        // restErrorHandler(error.status);
    }
};


export const downloadJournal = (serialNumber:string, role:string, setter: (value: RestApiState) => void, params: JournalRequestParams) => {
    setter(RestApiState.Pending);
    axios.get<any>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/acb/${serialNumber}/journal-download${generateQueryString(params)}`,
        { withCredentials: true, responseType: 'blob' }
    )
    .then(response => {
        if (response.status === 200) {
            // Create a URL for the file
            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const url = window.URL.createObjectURL(blob);

            // Create an anchor element and trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${serialNumber}_logs.xlsx`); // Replace with the desired file name
            document.body.appendChild(link);
            link.click();
            
            if (link.parentNode) {
                // Clean up the URL and remove the element
                link.parentNode.removeChild(link);
                window.URL.revokeObjectURL(url);
            }
           
            setter(RestApiState.Success);
        }
    })
    .catch(error => {
        setter(RestApiState.ServerError);
        // restErrorHandler(error.status);
    });
};